import { buildQueryString } from '../utils/buildQueryString'
import { createRestApiClient } from '../utils/createRestApiClient'

const BASE_URL = 'https://api.hyperliquid.xyz'

const createAuthHeaders = async (params: {
  /** 認証用 API Key */
  apiKey: string
  /** request headers 作成関数 (関数内で作成する headers を上書きして強制適用させる header) */
  createHeaders?: () => Promise<Record<string, string>>
}): Promise<Record<string, string>> => {
  const { createHeaders } = params

  // 強制適用する request headers 作成
  const overrideHeaders = createHeaders ? await createHeaders() : {}

  return {
    'Content-Type': 'application/json',
    ...overrideHeaders,
  }
}

export const createClient = ({
  apiKey,
  createHeaders,
  proxy,
}: {
  /** 認証用 API Key */
  apiKey: string
  /** request headers 作成関数 (関数内で作成する headers を上書きして強制適用させる header) */
  createHeaders?: () => Promise<Record<string, string>>
  /** request を proxy する場合の proxy base URL */
  proxy?: string
}) =>
  createRestApiClient({
    buildRequestData: async ({ method, path, query, body }) => {
      const queryString = buildQueryString(query)
      const queryWithQuestionMark = queryString ? `?${queryString}` : ''
      const url = `${BASE_URL}${path}${queryWithQuestionMark}`

      // requestBody に user (apiKey) を追加
      const requestBody = body ? { ...body, user: apiKey } : { user: apiKey }
      const bodyString = JSON.stringify(requestBody)

      const headers = await createAuthHeaders({
        apiKey,
        createHeaders,
      })

      return {
        url,
        headers,
        body: bodyString,
      }
    },
    getDelayForRetry: ({ statusCode }) => {
      // 401 エラーは 1秒待機してリトライ
      if (statusCode === 401) {
        return 1000
      }
      // 429 エラーは 10秒待機してリトライ
      if (statusCode === 429) {
        return 10_000
      }
      // 5xx エラーは 1秒待機してリトライ
      if (statusCode >= 500) {
        return 1000
      }
      // それ以外のエラーはリトライしない
      return undefined
    },
    proxy,
  })
